import { IPlacementClient } from './interfaces/placement-client.interface';
import { EXCO_Client } from './exco-client';
import { ExcoActions, Exco_SDK } from './exco.enums';
import { SubscriptionKey } from './exco.types';
import { ExcoPlacementIFrame } from './interfaces/exco-placement-iframe.interface';

export class EXCO_PlacementClient implements IPlacementClient {
  private _openClient: EXCO_Client;
  private _placementIFrame: ExcoPlacementIFrame;

  constructor(
    private readonly _placementId: string
  ) {
    this._openClient = new EXCO_Client();
  }

  public async mount(target: HTMLElement = document.body): Promise<this> { 
    try {
      const iframe = await this._openClient.mount(this._placementId, target);
      this._placementIFrame = iframe;
    } catch (error) {
      return error;
    }

    return this;
  }

  public unmount(): void {
    this._openClient.unmount(this._placementId);
    this._placementIFrame = null;
  }
  public publish(action: ExcoActions, data: any): void {
    this._openClient.publish(this._placementIFrame, action, data);
  }
  public subscribe(action: ExcoActions, callback: () => {}): SubscriptionKey {
    return this._openClient.subscribe(this._placementIFrame, action, callback);
  }
  public unsubscribe(key: SubscriptionKey): void {
    this._openClient.unsubscribe(this._placementIFrame, key);
  }
}
